import { useRef } from "react";
import initialAOLogo from "@assets/logo.png";
import userPlaceholder from "@assets/user.png";
import { Link } from "react-router-dom";
import UserPopup from "./UserPopup";
import { useAppSelector } from "@/hooks/useAppSelector";
import { TextSkeleton } from "./Skeletons";
import { PopupRef } from "devextreme-react/cjs/popup";
import { openPopup } from "@/helper/DxHelper";

function TopMenu({ inContext }: { inContext?: boolean }) {
  const userPopupRef = useRef<PopupRef>(null);
  const { content, title, isLoading, isError } = useAppSelector((state) => state.household.header);
  const { logoFile } = useAppSelector((state) => state.system);
  const { user } = useAppSelector((state) => state.system);

  return (
    <div
      className={
        "sticky overflow-x-scroll sm:overflow-x-hidden   left-0 top-0 z-[2000] h-[70px] w-full border-b border-b-neutral-400 bg-white"
      }
    >
      <div className={"flex h-full w-full items-center justify-between px-4"}>
        <Link className="flex-shrink-0" to={"/household"}>
          <img
            className="h-[65px]"
            src={logoFile?.fileValue ?? initialAOLogo}
            alt={logoFile?.name ?? "Advice One logo"}
          />
        </Link>
        {inContext && (
          <div className="flex flex-col items-center gap-1">
            <h1 className="text-2xl font-medium leading-none text-primary">{title}</h1>
            {isLoading ? (
              <div className="flex flex-col gap-2">
                <TextSkeleton height={1} width={27} />
                <TextSkeleton height={1} width={27} />
              </div>
            ) : null}
            {content ? (
              <span
                className={`text-sm font-medium ${isError ? "text-danger" : "text-neutral-100"}`}
              >
                {content}
              </span>
            ) : null}
          </div>
        )}
        <button
          id="user-data"
          onClick={() => openPopup(userPopupRef)}
          className="flex cursor-pointer items-center gap-4 print:hidden"
        >
          <span>{user?.name}</span>
          <img
            className="h-10 w-10 rounded-full"
            src={user?.photo || userPlaceholder}
            alt="user profile picture"
          />
        </button>
      </div>
      {user ? <UserPopup userPopupRef={userPopupRef} /> : null}
    </div>
  );
}

export default TopMenu;
